/**
 * Converts a decimal number to a percentage.
 *
 * @param {string | number} decimalNumber - The decimal number to be converted to a percentage.
 * @returns {string} - The percentage representation of the input decimal number.
 */

export function convertToPercentage(
  decimalNumber: string | number,
  decimalPlaces = 2
): string {
  // Convert the input to a number
  const parsedNumber =
    typeof decimalNumber === 'string'
      ? parseFloat(decimalNumber)
      : decimalNumber;

  // Check if the conversion was successful
  if (isNaN(parsedNumber)) {
    return 'Invalid input. Please provide a valid number or string representation of a number.';
  }

  // Convert the decimal to a percentage and round to the specified decimal places
  const percentage = (parsedNumber * 100).toFixed(decimalPlaces);

  // Add the percentage symbol and return the result
  return `${percentage}%`;
}
